import React from 'react'
import socialStyle from '../index.module.scss'
import SocialLogin from 'react-social-login'
import config from '@config/index'

const GButton = SocialLogin(({ children, triggerLogin, ...props }) => (
  <button type="button" onClick={triggerLogin} {...props}>
    {children}
  </button>
))
const handleSocialLogin = (user, props, method) => {
  props.onSocialSubmit(user, method)
}

const handleSocialLoginFailure = (err, props) => {
  console.error(err)
  props.onSocialError()
}

const SocialButton = (props) => {
  return (
    <React.Fragment>
      {props && props.showItems && props.showItems.includes('google') && (
        <GButton
          id="googleLoginButton"
          className={`btn btn-xl btn-outline align-items-center justify-content-center btn-block d-flex 
        ${props.googleCustomClass ? props.googleCustomClass : null}`}
          provider='google'
          appId={config.google_login_key}
          onLoginSuccess={(user) => handleSocialLogin(user, props, 'google')}
          onLoginFailure={(err) => handleSocialLoginFailure(err, props)}
        >
          <i className={`mr-10 position-relative top-minus-1 ${socialStyle['b-icon']}`}>
            <img className="google-icon d-block" alt="" src="https://s3-us-west-1.amazonaws.com/gosite-assets/image/google-icon.png" />
          </i>
          <span className="position-relative top-1">{props.googleText ? props.googleText : props.googleSignupText}</span>
        </GButton>

      // https://gitlab.com/gositeinc/gosite-react/-/commit/edfb0e6811529b9232a0fba56b0dd2b6911ca264?page=2

      // <GButton
      //   id="googleLoginButton"
      //   className={`btn btn-xl btn-outline align-items-center justify-content-center btn-block d-flex
      //         ${props.googleCustomClass ? props.googleCustomClass : null} ${socialStyle['google-button']}`}
      //   provider="google"
      //   scope={
      //     'email profile https://www.googleapis.com/auth/plus.business.manage https://www.googleapis.com/auth/calendar'
      //   }
      //   appId={config.google_login_key}
      //   onLoginSuccess={(user) => handleSocialLogin(user, props, 'google')}
      //   onLoginFailure={(err) => handleSocialLoginFailure(err, props)}>
      //   <i className={`mr-10 position-relative top-minus-1 ${socialStyle['b-icon']}`}>
      //     <img
      //       className="google-icon d-block"
      //       alt=""
      //       src="https://s3-us-west-1.amazonaws.com/gosite-assets/image/google-icon.png"
      //     />
      //   </i>
      //   <span className="position-relative top-1">
      //     {props.googleText ? props.googleText : props.googleSignupText}
      //   </span>
      // </GButton>
      )}
      {props && props.showItems && props.showItems.includes('facebook') && (
        <GButton
          id="facebookLoginButton"
          className={`btn btn-xl btn-outline align-items-center justify-content-center btn-block d-flex 
                ${props.fbCustomClass ? props.fbCustomClass : null}`}
          provider="facebook"
          appId={config.facebook_client_id}
          onLoginSuccess={(user) => handleSocialLogin(user, props, 'facebook')}
          onLoginFailure={(err) => handleSocialLoginFailure(err, props)}
          scope="pages_manage_cta,pages_show_list,pages_manage_engagement,pages_manage_metadata,pages_manage_posts,pages_read_engagement,pages_read_user_content,user_photos,read_insights,pages_messaging">
          <i className={`mr-10 position-relative top-minus-1 ${socialStyle['b-icon']}`}>
            <img
              className="d-block"
              alt=""
              src={
                props.fbImgUrl
                  ? props.fbImgUrl
                  : 'https://dufzo4epsnvlh.cloudfront.net/image/signup/temp-2/facebook.svg'
              }
            />
          </i>
          <span className="position-relative top-1">{props.fbText}</span>
        </GButton>
      )}
      {props && props.showItems && props.showItems.includes('email') && (
        <button
          className={
            'btn btn-xl btn-outline align-items-center justify-content-center btn-block mb-0 ' +
            socialStyle['btn-custom']
          }
          onClick={props.action}>
          <i className={`mr-10 position-relative top-minus-1 ${socialStyle['b-icon']}`}>
            <img className="d-block" alt="" src="https://dufzo4epsnvlh.cloudfront.net/image/signup/temp-2/email.svg" />
          </i>
          <span className="position-relative top-1">EMAIL</span>
        </button>
      )}
    </React.Fragment>
  )
}
export default SocialButton
